import ComponentManager from '@/Management/ComponentManager';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import Utilities from '@/Utility/Utilities';
import { IFilterable } from '#/DefaultViewExtensionInterfaces';
import { IListViewDTO } from "coreframetypings/dto";

export default class FilterLinkViewModel extends ToolBarLinkViewModel {

    protected dataSource: IFilterable;
    protected listView: KnockoutObservable<IListViewDTO>;

    public constructor(protected params: any) {
        super($.extend({
            ergName: Utilities.isMobileView() ? null : 'FILTER',
            tooltipErgName: 'FILTER_TOOLTIP',
            imageSource: GlobalConfiguration.inlineImages.FILTER,
            locator: 'filter'
        }, params));

        this.dataSource = this.paramOrDefault(this.params.dataSource, null);
        this.setRequiredObservables();

        this.defineSubscription(this.isActive, (isActive) => {
            this.dataSource?.filter?.isVisible(isActive);
        });
    }

    /**
     * @override 
     */
    protected createIsVisibleObservable(): KnockoutObservable<boolean> {
        if (!Utilities.isNullOrUndefined(this.params.isVisible)) {
            return this.observableOrDefault(this.params.isVisible);
        }

        this.setRequiredObservables();

        return this.createWritableComputed(() => this.listView().showFilter);
    }

    /**
     * @override 
     */
    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {
        const filter = this.dataSource?.filter;
        if (this.isActive()) {
            
            filter?.resetFilter();

            if (!_.isEmpty(filter?.filterChipsViewModel?.activeChips())) {
                filter?.filterChipsViewModel?.activeChips([]);
            }

            this.isActive(false);
        }
        else {
            this.isActive(true);
        }

        filter?.rearrange();
    }

    public showFilter(): void {
        this.isActive(true);
    }

    private setRequiredObservables(): void {
        if (Utilities.isNullOrUndefined(this.listView)) {
            this.listView = this.observableOrDefault(this.params.listView);
        }
    }
}

ComponentManager.setViewModel('FilterLink', FilterLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');